"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pipe = void 0;
var _pipe = function _pipe(a, b) {
  return function (arg) {
    return b(a(arg));
  };
};
var pipe = function pipe() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }
  return ops.reduce(_pipe);
};
exports.pipe = pipe;